import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { myConnections } from "@/react/helpers/urlHelpers/internalApi/myConnections";
import type { CommunityMember } from "@/react/types/CommunityMember";

export interface GetMyConnectionsResponse {
  count: number;
  has_next_page: boolean;
  page: number;
  page_count: number;
  per_page: number;
  records: CommunityMember[];
}

export const myConnectionsApi = {
  getMyConnections: (params: { page: number; per_page: number }) =>
    reactQueryGet<GetMyConnectionsResponse>(myConnections.index(params)),
};
